import styled from 'styled-components'

export const IconButton = styled.div`
  display: grid;
  color: var(--text-10);
  cursor: pointer;
  transition: color 0.15s linear;

  &:hover {
    color: var(--text-11);
  }
`
